import React from 'react';
import { FaSun, FaMoon } from 'react-icons/fa';
import '../styles/ThemeToggle.css';

const ThemeToggle = ({ isDarkMode, toggleTheme }) => {
  return (
    <button 
      className={`theme-toggle ${isDarkMode ? 'dark' : 'light'}`}
      onClick={toggleTheme}
      aria-label="Toggle theme"
    >
      <div className="theme-toggle-inner">
        {isDarkMode ? <FaSun className="sun-icon" /> : <FaMoon className="moon-icon" />}
      </div>
    </button>
  );
};

export default ThemeToggle; 